var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLaneDepartureWarning24 = function SvgLaneDepartureWarning24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.262 4.95 1.715.65a3.108 3.108 0 0 1 1.804 4.007l-3.22 8.494a2.61 2.61 0 0 1-3.365 1.516l-2.645-1.003a2.61 2.61 0 0 1-1.515-3.365l3.22-8.495a3.107 3.107 0 0 1 4.006-1.804Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14.711 8.757 1.925.73a3.006 3.006 0 0 1 1.745 3.876l-1.226 3.235a.82.82 0 0 1-1.058.476l-6.013-2.28a.82.82 0 0 1-.475-1.057l1.23-3.245a3.006 3.006 0 0 1 3.872-1.735v0Zm-3.607.99-1.801-.683m11.15 4.227-1.8-.683",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 2v20",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.37 3.28 1.37 3.28 1.37 3.28"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 15v7m0-20v3",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgLaneDepartureWarning24;